/**
 * GanttChartEditor
 *
 * Property editor for Gantt chart configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { TextPropertyEditor } from '../../BaseEditors/TextPropertyEditor';

export interface GanttChartEditorProps {
  config: Partial<ChartBaseConfig & {
    nameKey?: string;
    startKey?: string;
    durationKey?: string;
    progressKey?: string;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const GanttChartEditor: React.FC<GanttChartEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Gantt Chart" showAxes={false}>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Gantt Options</h3>

        <TextPropertyEditor
          label="Task Name Key"
          value={(config.nameKey as string) || 'name'}
          onChange={(nameKey) => onChange({ ...config, nameKey })}
          helpText="Property for task names"
          required
        />

        <TextPropertyEditor
          label="Start Time Key"
          value={(config.startKey as string) || 'start'}
          onChange={(startKey) => onChange({ ...config, startKey })}
          helpText="Property for task start position"
          required
        />

        <TextPropertyEditor
          label="Duration Key"
          value={(config.durationKey as string) || 'duration'}
          onChange={(durationKey) => onChange({ ...config, durationKey })}
          helpText="Property for task duration"
          required
        />

        <TextPropertyEditor
          label="Progress Key"
          value={(config.progressKey as string) || 'progress'}
          onChange={(progressKey) => onChange({ ...config, progressKey })}
          helpText="Property for completion % (0-1)"
        />
      </div>
    </ChartBaseEditor>
  );
};

GanttChartEditor.displayName = 'GanttChartEditor';
